const modules = import.meta.glob('./*.ts', { eager: true })
const lang: Record<string, any> = {}

for (const path in modules) {
  // Exclude index.ts itself
  if (path.includes('index.ts')) continue
  
  // Get filename as key, e.g., ./common.ts -> common
  const name = path.replace(/^\.\/(.*)\.\w+$/, '$1')
  lang[name] = (modules[path] as any).default
}

export default lang
